/**
 * API Configuration
 * Central place to configure backend API URL
 */

// Use Railway URL in production, localhost in development
const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';

export default API_URL;

